<div [ngClass]="formatter">
  <label
    class="bl-label bl-font-weight--800 bl-font-size--14"
    [class.bl-required]="field.required"
    [for]="field.id"
    [id]="field.id + '-label'"
  >
    {{ field.label }}
    @if (field.config.tooltip) {
      <button aria-label="tooltip" type="button" class="bl-font-color--blue bl-margin-left--4">
        <i eaTooltip="{{ field.config.tooltip }}" class="cu-info-circle"></i>
      </button>
      <span id="tooltip-info-{{ field.id }}" class="bl-screen-reader-only">{{ field.config.tooltip }}</span>
    }
  </label>
  <input
    #input
    type="text"
    class="bl-input"
    [attr.aria-describedby]="field.id + '-desc-container'"
    [attr.aria-labelledby]="fieldLabelledBy"
    [attr.data-automation-id]="field.automationId"
    [attr.inputmode]="field.inputMode"
    [cuFieldState]="field"
    [disabled]="!field.enabled"
    [hidden]="showObfuscatedValue"
    [id]="field.id"
    [placeholder]="field.config.placeholder || ''"
    [(ngModel)]="maskedValue"
    (blur)="focused = false; processMask(false)"
    (cut)="processMask()"
    (focus)="focused = true; processMask()"
    (input)="processMask()"
    (keydown.enter)="$event.target['blur']()"
    (keyup)="processMask()"
    (mouseup)="processMask()"
    (paste)="processMask()"
    (selectionchange)="processMask()"
  />
  <input
    type="text"
    class="bl-input"
    [attr.aria-labelledby]="field.id + '-label'"
    [attr.inputmode]="field.inputMode"
    [hidden]="!showObfuscatedValue"
    [id]="field.id + '_obfuscate'"
    [(ngModel)]="obfuscatedValue"
    (keydown)="onMaskFieldKeydown($event)"
  />
  <button id="reveal-password" type="button" class="bl-input-append input-eye-icon" (click)="showUnObfuscatedValue()">
    <i [ngClass]="showObfuscatedValue ? 'cu-eye' : 'cu-eye-slash'"></i>
    <span class="bl-screen-reader-only">
      {{ (showObfuscatedValue ? ('obfuscatedInput/show' | dictionary) : ('obfuscatedInput/hide' | dictionary)) + ' ' + field.label }}
    </span>
  </button>
</div>
